import React from 'react'
import Typewriter from "typewriter-effect";
import im2 from "./abo.gif";

import "./about.css";
import {Link} from 'react-router-dom';
export default function About() {
	return (
		<div>
			<h1 className="text-center font-bold h2h ">About Me.</h1>
<div className="d-flex justify-content-around align-items-center flex-wrap">
<div style={{width:"887px"}}>
<h2 className="text-center hh1 " style={{marginTop:"55px"}}>



<Typewriter
  

options={{
    delay: 75,
    autoStart: true,
    loop: true,
  }}


       onInit={(typewriter)=> {

       typewriter
        
       .typeString("Hello 👋, welcome to my portfolio .")
         

         .pauseFor(200)
       .deleteAll()
       .typeString("My name is Anurag Tiwari.")

       .pauseFor(200)
       .deleteAll()
       .typeString(" I'am a Programmer.")


       .pauseFor(500)
       .deleteAll()
       .typeString("An IT student.")


       .pauseFor(500)
       .deleteAll()
       .typeString("Also a teacher.")


.pauseFor(500)
       .deleteAll()
       .typeString(" And i love to explore new technologies.")

       .start();
       }}
       /> </h2>
 </div>

<div className="imd" style={{width:"400px"}}>
<img src={im2}  style={{height:"100%",marginTop:"40px"}} />
</div>
</div>
<h3 className="text-center hh1 ">Check out my   <Link to="/projects" style={{color:"black"}}>projects!</Link></h3>
		</div>

	)
}